var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:('font-size: ' + this.size)},[_c('span',{staticStyle:{"font-size":"0.9em","font-family":"'Crimson Text'","vertical-align":"0"}},[_vm._v("Boss")]),_c('span',{staticStyle:{"font-family":"'Crimson Text'"}},[_vm._v("DB")])])}
var staticRenderFns = []

export { render, staticRenderFns }